var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.937501C13.4475 0.937501 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625C4.5525 17.0625 0.9375 13.4475 0.937501 9C0.937501 4.5525 4.5525 0.9375 9 0.937501ZM9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375Z",
    fill: "#586370"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.6875C9.3075 7.6875 9.5625 7.9425 9.5625 8.25L9.5625 12C9.5625 12.3075 9.3075 12.5625 9 12.5625C8.6925 12.5625 8.4375 12.3075 8.4375 12L8.4375 8.25C8.4375 7.9425 8.6925 7.6875 9 7.6875Z",
    fill: "#586370"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.24985C9.0975 5.24985 9.195 5.27235 9.285 5.30985C9.375 5.34734 9.4575 5.39985 9.5325 5.46735C9.6 5.54235 9.6525 5.61735 9.69 5.71485C9.7275 5.80485 9.75 5.90235 9.75 5.99985C9.75 6.09735 9.7275 6.19485 9.69 6.28485C9.6525 6.37485 9.6 6.45735 9.5325 6.53235C9.4575 6.59985 9.375 6.65235 9.285 6.68985C9.105 6.76485 8.895 6.76485 8.715 6.68985C8.625 6.65235 8.5425 6.59985 8.4675 6.53235C8.4 6.45735 8.3475 6.37485 8.31 6.28485C8.2725 6.19485 8.25 6.09735 8.25 5.99985C8.25 5.90235 8.2725 5.80485 8.31 5.71485C8.3475 5.61735 8.4 5.54235 8.4675 5.46735C8.5425 5.39985 8.625 5.34734 8.715 5.30985C8.805 5.27235 8.9025 5.24985 9 5.24985Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.a206f0befe234d79d9d80353418b5774.svg";
export { ForwardRef as ReactComponent };